import AccordionPanel from '@/components/Accordion/panels/FormGroup'; // import styles from './styles.module.scss';

import { jsx as _jsx } from "react/jsx-runtime";

const QuestionGroup = _ref => {
  let {
    heading = '',
    isOpen,
    isToggleable,
    className,
    onClick,
    children
  } = _ref;
  return /*#__PURE__*/_jsx(AccordionPanel, {
    title: heading,
    className: className || '',
    isOpen: isOpen,
    isToggleable: isToggleable,
    onClick: onClick,
    children: children
  });
};

export default QuestionGroup;